import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, convertToUTCISOString, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import { ICall } from "../../DTO/Dto";
import CallDrawyer from "./DrawyerPages/CallDrawyer";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewCallContact: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getCallPermission;
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const params = useParams();
    const { id, meetingId } = params
    const [open, setOpen] = React.useState(false);
    const [callLogListData, setCallLogListData] = useState<any>([])
    const [resetLoad, setResetLoad] = useState(false)
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [formComponent, setFormComponent] = useState<any>()
    const isMobile = IsSmallScreen();
    const resetTrigger = useSelector((state: any) => state.components?.callLogContactGrid?.resetTrigger);
    useEffect(() => {
        if (resetTrigger) {
            const getCalls = async () => {
                try {
                    setResetLoad(false)
                    const response: any = await callAPI('call-logs/lead', Method.GET, null, id);
                    if (response.data) {
                        setCallLogListData(response?.data || []);
                    }
                }


                catch (e) {

                }
            }
            if (id) {
                getCalls();
            }
        }
    }, [resetTrigger]);
    useEffect(() => {

        const getMeetings = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI('call-logs/lead', Method.GET, null, id);
                if (response?.data) {
                    setCallLogListData(response.data || []);
                }
            }
            catch (e) {
            }
        }
        if (id) {
            getMeetings();
        }
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'dateTime',
            isHide:isMobile
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,
            isHide:isMobile,
            type: 'status'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            const form: any = <CallDrawyer
                id={id}
                control={control}
                register={register}
                callId={row.id}
                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

            />
            setFormComponent(form)
            setTimeout(() => {
                setOpen(true)
            }, 10);
        }
    }
    const handleCallData = async (data: any) => {
        try {
            dispatch(storeDataComponent('callSubmit', { loading: true }));
            const response: any = await saveData(data);
            if (response && response?.message) {
                dispatch(resetDataComponent('callLogContactGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('callLogContactGrid'));
                setResetLoad(true)
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(true)
        }
        finally {
            dispatch(updateDataComponent('callSubmit', { loading: false }));
        }

    }
    const saveData = async (data: ICall) => {
        const callStart: any = convertToUTCISOString(data?.callStart.toString())

        const request: ICall = {
            callType: data?.callType || "",
            callStart: callStart || "",
            callDuration: Number(data.callDuration) || 0,
            callPurpose: data?.callPurpose || "",
            leadId: id || "",
            callResult: data.callResult || "",
            description: data.description,
            subject: data?.subject || "",
            callStatus: data?.callStatus

        }
        if (data?.callId) {
            const response: any = await callAPI("call-logs", Method.PUT, request, data.callId);
            return response
        } else {
            const response: any = await callAPI("call-logs", Method.POST, request);
            return response
        }
    }

    const handleDealsClick = () => {

        const form: any = <CallDrawyer
            id={id}
            control={control}
            register={register}
            reset={reset}
            setValue={setValue}
            onCancel={() => { reset(); setOpen(false) }}

        />
        setFormComponent(form)
        setTimeout(() => {
            setOpen(true)
        }, 10);
    }

    return (
        <Grid>
            <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
                {view ? <Grid item xs={12}>
                    <WSDataGrid

                        id="callLogContactGrid"
                        title="Calls"
                        data={callLogListData}
                        columns={columns}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}

                        onAddButtonClick={handleDealsClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                    />
                </Grid>

                    : <PermissionDenied />}
            </Grid>
            {formComponent && <SwipeableDrawerForm anchor="right" title={'Calls'}
                openForm={open}
                formComponent={<form onSubmit={handleSubmit(handleCallData)}>
                    {formComponent}
                </form>}
                onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

            />}

        </Grid>
    );
});
